export const CORRECTION_HEATING = 1
export const CORRECTION_COOLING = 2
export const CORRECTION_ABSOLUT = 3

export const correctionTypeData = [
  { label: 'Absolut', value: CORRECTION_ABSOLUT, short: 'ABS' },
  { label: 'Heizgradtage', value: CORRECTION_HEATING, short: 'HGT' },
  { label: 'Kühlgradstunden', value: CORRECTION_COOLING, short: 'KGS' },
]
